import Classes from "./styles/style.module.css";
import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../MainSlider/styles/slickStyles.css";
import VideoBanner from "../../components/VideoBanner";
import Banner from "../../components/banner";

export default function BannerSlider({ banners, smallVideo }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const settings = {
    arrows: false,
    infinite: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: "20px",
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_, next) => setCurrentSlide(next),
    afterChange: (current) => setCurrentSlide(current),
  };

  const settingsSingle = {
    arrows: false,
    infinite: false,
    dots: false,
    autoplay: false,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: "0px",
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_, next) => setCurrentSlide(next),
    afterChange: (current) => setCurrentSlide(current),
  };

  const sortedBanners = [...banners].sort((a, b) => b.index - a.index);

  return (
    <div className="col-12 px-1">
      <div className={Classes.SliderContainer}>
        <div>
          {sortedBanners.length > 1 ? (
            <Slider {...settings}>
              {banners.map((banner, index) => {
                if (banner.type === "Image") {
                  return (
                    <Banner
                      topbanner={true}
                      src={banner.src}
                      href={banner.link}
                      linkNewTab={banner.linkNewTab ? banner.linkNewTab : false}
                      title={banner.title}
                      showText={banner.titleVisible}
                      date={banner.timer ? banner.timer : ""}
                      dateLabel={banner.timerLabel}
                      glow={banner.highlight}
                      key={index}
                    />
                  );
                } else {
                  return (
                    <VideoBanner
                      bannerData={banner}
                      key={currentSlide}
                    />
                  );
                }
              })}
            </Slider>
          ) : (
            <Slider {...settingsSingle}>
              {banners.map((banner, index) => {
                if (banner.type === "Image") {
                  return (
                    <Banner
                      topbanner={true}
                      src={banner.src}
                      href={banner.link}
                      linkNewTab={banner.linkNewTab ? banner.linkNewTab : false}
                      title={banner.title}
                      showText={banner.titleVisible}
                      date={banner.timer ? banner.timer : ""}
                      dateLabel={banner.timerLabel}
                      glow={banner.highlight}
                      key={index}
                    />
                  );
                } else {
                  return (
                    <VideoBanner
                      bannerData={banner}
                      key={currentSlide}
                      smallVideo={smallVideo}
                    />
                  );
                }
              })}
            </Slider>
          )}
        </div>
      </div>
    </div>
  );
}
